import * as PIXI from 'pixi.js';
import { FrontendErrorCode, PlayWindow } from "../../api";
import { ISystemContext } from "../../Context/SystemContext";
import { CreateElement, Log, Point, Rect, Safe, Scale, Size } from "../../MyHelpers";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { service } from "../../services";
import { Settings } from "../../Settings";
import { ParseMonitors } from "../../system/ParseMonitors";
import { ZIndex } from "../../ZIndex";
import { MyCanvas } from "../MyCanvas";
import { SymbolPositionToAnimate } from "../SymbolsAnimation";
import { ISpinnableReels, SpinnableReelsParams } from "./SpinnableReels";
import { OnDestroyCallbackHandler } from '../FillingPot/FillingPotGeneric';




export class SpinnableReelsBigCanvas implements ISpinnableReels {

	//protected numReels: number = 0;
	//protected numRows: number = 0;

	// window size in number of symbols
	protected windowSymbolSize: PlayWindow;

	// total window size in number of ymbols, including hidden symbols
	protected extendedWindowSymbolSize: Size


	// additional rows to add on tom of animation
	public readonly numAdditionalRowsTop: number = 1;

	// size of whole window, in pixels
	protected windowRect: Rect = null;

	// size of one symbol. in pixels
	protected symbolSize: Size = new Size();

	protected centerOfReel: Point[] = [];

	//protected symbolWidth: number = 0;
	//protected symbolHeight: number = 0;

	protected slotWindowElement: HTMLElement = null;
	protected reelWindowElemsList: PIXI.Container[] = [];
	public get ReelWindowElements(): PIXI.Container<PIXI.DisplayObject>[] {
		return this.reelWindowElemsList;
	}

	public reelElemsList: PIXI.Container[] = [];
	public get ReelElements(): PIXI.Container<PIXI.DisplayObject>[] {
		return this.reelElemsList;
	}

	protected reelWindowMaskList: PIXI.Container[] = [];
	public get ReelWindowMask(): PIXI.Container<PIXI.DisplayObject>[] {
		return this.reelWindowMaskList;
	}

	//protected spinAnimation: SpinAnimation = null;
	//protected reelSetMapper: ReelSetMapper = null;

	protected logGroup: string = "SpinnableReels";

	// canvas element for each symbol
	// first index = reel index
	// second index = row index
	//public canvas: MyCanvas[][] = [];
	public symbolPIXISprite: PIXI.AnimatedSprite[][] = [];
	public symbolContainerSprite: PIXI.Container[][] = [];

	protected params: SpinnableReelsParams = null;
	//protected symbols: SlotSymbol[] = null;
	protected resid: ResourceIdentifier = null;

	public app: PIXI.Application<HTMLCanvasElement> = null;

	protected systemContext : ISystemContext = null;
	//protected restoreWebGlInterval : IInterval = null;

	protected reelBackgroundRect : Rect[] = [];

	public constructor(windowSymbolsSize: PlayWindow, windowRect: Rect, params: SpinnableReelsParams = null, resid: ResourceIdentifier , systemContext: ISystemContext) {
		this.windowSymbolSize = windowSymbolsSize;

		this.params = params;		
		this.systemContext = systemContext.CreateSubContext("SpinnableReelsBigCanvas");

		// fill in default values to simplify flow
		if (!this.params) this.params = {};
		if (!this.params.topBorderWidth) this.params.topBorderWidth = 0;
		if (!this.params.rightBorderWidth) this.params.rightBorderWidth = 0;
		if (!this.params.bottomBorderWidth) this.params.bottomBorderWidth = 0;
		if (!this.params.leftBorderWidth) this.params.leftBorderWidth = 0;

		// extended size, for hidden symbols on top
		this.extendedWindowSymbolSize = new Size(windowSymbolsSize.Width, windowSymbolsSize.Height + this.numAdditionalRowsTop);
		this.windowRect = windowRect;

		// find symbol size, based on window size and number of reels/rows
		let windowInnerWidth = this.windowRect.width - this.params.leftBorderWidth - this.params.rightBorderWidth;
		let windowInnerHeight = this.windowRect.height - this.params.topBorderWidth - this.params.bottomBorderWidth;

		// this is now inner window size, reduced by border
		let windowInnerRect = new Rect(this.params.leftBorderWidth, this.params.topBorderWidth, windowInnerWidth, windowInnerHeight);

		//// Log.Debug(this.logGroup, "Inner window rect (borders compensated): " + windowInnerRect.toString());

		let symbolWidth = windowInnerRect.width / this.windowSymbolSize.Width;
		// if (symbolWidth - Math.round(symbolWidth) != 0) {
		// 	Log.Error(this.logGroup, "Window width is not equally divisible by number of symbols: window width = " + this.windowRect.width + ", reels = " + this.windowSymbolSize.width);
		// }

		let symbolHeight = windowInnerRect.height / this.windowSymbolSize.Height;
		// if (symbolHeight - Math.round(symbolHeight) != 0) {
		// 	Log.Error(this.logGroup, "Window height is not equally divisible by number of symbols: window height = " + this.windowRect.height + ", symbols = " + this.windowSymbolSize.height);
		// }

		this.symbolSize = new Size(Math.round(symbolWidth), Math.round(symbolHeight));
		console.log(`SymbolsSize-${this.resid}:`,this.symbolSize);

		this.resid = resid.Add("SpinnableReelsBigCanvas");

		// prepare slot window
		this.slotWindowElement = CreateElement("div", {
			classes: ["spinnablereels-slotwindow"], style: {
				position: "absolute",
				//left: this.windowRect.x + "px",
				//top: this.windowRect.y + "px",
				width: Scale.W(1920) + "px",
				height: Scale.W(1080) + "px",
			}
		});


		// this.restoreWebGlInterval = this.systemContext.TimingContext().CreateInterval("restoreWebGlInterval", 500, () => {
		// 	let success = this.tryRecoverWebglContext();

		// 	// success, stop timer
		// 	if (!success)
		// 	{
		// 		this.recoverFailCount++;
		// 		if (this.recoverFailCount == this.maxRecoverFailCount)
		// 		{
		// 		    void service.api.frontendError(FrontendErrorCode.WebGLRecoverFail, `${this.resid.ID()} in ${this.recoverFailCount} tries`);
		// 		}
		// 	}
		// });
	}


	protected recoverCount: number = 0;
	protected recoverFailCount: number = 0;
    protected readonly maxRecoverFailCount = 5;

	protected failed: boolean = false;

	protected tryRecoverWebglContext(): boolean
	{
		if (!this.created)
		{
			//this.restoreWebGlInterval.Stop();
			this.recoverFailCount = 0;

			// app not created, don't care
			return true;
		}

		console.log(this.resid.ID() + " trying to recover");
	    void service.api.frontendError(FrontendErrorCode.WebGLContextRecovering, `${this.resid.ID()}`);
		try
		{
		    void service.api.frontendError(FrontendErrorCode.WebGLDestroy, `${this.resid.ID()}`);
			this.InternalDestroy();
		    void service.api.frontendError(FrontendErrorCode.WebGLDestroySuccess, `${this.resid.ID()}`);
		}
		catch (ex)
		{
		    void service.api.frontendError(FrontendErrorCode.WebGLDestroyError, `${this.resid.ID()}: ${ex.toString()}`);
		}

		try
		{
			// Log.Debug(this.logGroup, `tryRecoverWebglContext() ${this.resid.ID()} recreating`);
		    void service.api.frontendError(FrontendErrorCode.WebGLCreate, `${this.resid.ID()}`);
			this.InternalCreate();

			// all fine, stop timer
			//this.restoreWebGlInterval.Stop();
            console.log(this.resid.ID() + " recover success");

			this.recoverCount++;
			//this.restoreWebGlInterval.Stop();
			this.recoverFailCount = 0;

		    void service.api.frontendError(FrontendErrorCode.WebGLCreateSuccess, `${this.resid.ID()}`);
		    void service.api.frontendError(FrontendErrorCode.WebGLContextRecovered, `${this.resid.ID()}, recover count: ${this.recoverCount}`);

			return true;
		}
		catch (ex)
		{
		    void service.api.frontendError(FrontendErrorCode.WebGLCreateError, `${this.resid.ID()}, ${ex.toString()}`);

			console.log(this.resid.ID() + " error recovering", ex);

            // prevent spamming the backend
            if (this.recoverFailCount < this.maxRecoverFailCount)
            {
				

                if (ex.message.toLowerCase().includes("this browser does not support webgl"))
                {
                       void service.api.frontendError(FrontendErrorCode.WebGLNotSupported, `${this.resid.ID()}, error: ${ex.toString()}`);
                }
                else
                {
                       void service.api.frontendError(FrontendErrorCode.WebGLRecoverError, `${this.resid.ID()}, error: ${ex.toString()}`);
                }
            }
		}

		return false;
	};

	protected lostCount: number = 0;
	protected webglcontextlost()
	{
		this.lostCount++;
		Log.Error(this.logGroup, `Webgl context lost, count: ${this.lostCount}`);
	    void service.api.frontendError(FrontendErrorCode.WebGLContextLost, `${this.resid.ID()}, count: ${this.lostCount}`);

		// try recover right now, or start timer to try recover later
		let success = this.tryRecoverWebglContext();
		if (success)
		{
			// all good
			return;
		}
		
		// error recovering, start timer
		//this.restoreWebGlInterval.Start();
	}

    protected webglcontextlostInstance: () => void = this.webglcontextlost.bind(this);

	//public slotTextures = [];	
	protected reelBackgroundTexture : PIXI.Texture = null;
	protected reelBackgroundMaskTexture : PIXI.Texture  = null;
	public ResourcesLoaded(pixiSpritesByName : Map<string, any[]> , reelBackgroundTexture : PIXI.Texture , reelBackgroundMaskTexture : PIXI.Texture) {
		//contruct reels whit data
		//this.ConstructReels();
		//this.spritesByName = pixiSpritesByName;
		this.reelBackgroundTexture = reelBackgroundTexture;
		this.reelBackgroundMaskTexture = reelBackgroundMaskTexture;
		//console.log("textureReelBackgroundParams",this.reelBackgroundTexture);				
		//console.log("textureReelBackgroundParams",this.reelBackgroundTexture);				

	}

	//protected resourcesNames: string[] = [];
	//public spritesByName: Map<string, any[]> = new Map<string, any[]>();
	//protected reels = [];
	protected reelContainer: PIXI.Container = null;
	protected reelContainerBackground: PIXI.Container = null;

	protected ConstructReels() {
	
		// //console.log("frameByGames:", this.spritesByName);
		// let framesGame = [];


		// for (let value of this.spritesByName.values()) {
		// 	//console.log(value);
		// 	framesGame.push(value);
		// 	value = null;
		// }

		const AspectFixY = ParseMonitors().AspectFixY;


		let REELWIDTH = this.symbolSize.Width ;
		let startReelPosition = 0;

		let reelContainerBackground = new PIXI.Container();
		reelContainerBackground.name= "reelContainerBackgroundPIXI";
		reelContainerBackground.width = this.windowRect.width;
		reelContainerBackground.height = this.windowRect.height;
		reelContainerBackground.x = this.windowRect.x;
		reelContainerBackground.y = this.windowRect.y;
		reelContainerBackground.zIndex = ZIndex.ReelContainerBackground;
		this.reelContainerBackground = reelContainerBackground;

		// Build the reels
		//const reels = [];
		let reelContainer = new PIXI.Container();
		reelContainer.name= "reelContainerPIXI";
		reelContainer.width = this.windowRect.width;
		reelContainer.height = this.windowRect.height;
		reelContainer.x = this.windowRect.x;
		reelContainer.y = this.windowRect.y;
		this.reelContainer = reelContainer;

		for (let ri = 0; ri < this.windowSymbolSize.Width; ri++) {
			this.symbolPIXISprite.push([]);
			this.symbolContainerSprite.push([]);

			//add rell background
			
			let reelBackground = new PIXI.Sprite(this.reelBackgroundTexture);
			reelBackground.name = "reelBackground";
			reelBackground.x = (ri * REELWIDTH) + startReelPosition;
			reelBackground.zIndex = ZIndex.ReelContainerBackground;
			reelBackground.y = this.params.topBorderWidth;
			reelBackground.height = this.windowRect.height;
			reelBackground.width = REELWIDTH;

			this.reelBackgroundRect.push(new Rect(reelBackground.x, reelBackground.y, reelBackground.width, reelBackground.height ))

			//create mask for limit reels
			//its disable mask img 
			
			let reelMask = new PIXI.Sprite(this.reelBackgroundMaskTexture);
			reelMask.x = (ri * REELWIDTH) + startReelPosition;
			reelMask.y = this.params.topBorderWidth;
			reelMask.height = this.windowRect.height;
			reelMask.width = REELWIDTH;
			this.reelWindowMaskList.push(reelMask);
			//create container for reel 			
			let rc = new PIXI.Container();
			rc.name = "reelContainer"
			rc.x = (ri * REELWIDTH) + startReelPosition;
			rc.y = this.params.topBorderWidth;
			rc.height = this.windowRect.height;
			rc.width = REELWIDTH;

			//rc.y = 0;	
			// let symbols: PIXI.AnimatedSprite[] = [];
			// let reel = {
			// 	container: rc,
			// 	symbols: symbols,
			// 	position: 0,
			// 	previousPosition: 0,
			// 	blur: new PIXI.filters.BlurFilter(),
			// 	ZIndex: ZIndex.ReelContainer
			// };
			


			this.reelWindowElemsList.push(reelBackground);
			this.reelElemsList.push(rc);
			let positionStart = (this.symbolSize.Height) * -1;

			// Build the symbols
			let incZIndex = this.extendedWindowSymbolSize.Height;
			for (let si = 0; si < this.extendedWindowSymbolSize.Height; si++) {

				//create symbols container
				let symbolContainer = new PIXI.Container();
				symbolContainer.name = "symbolAllContainer"
				symbolContainer.height = this.symbolSize.Height;
				symbolContainer.width = this.symbolSize.Width;
				symbolContainer.x = Math.round((REELWIDTH - this.symbolSize.Width) / 2);
				symbolContainer.y = positionStart + this.params.topBorderWidth + this.params.bottomBorderWidth;
				symbolContainer.accessibleChildren = true;
				rc.addChild(symbolContainer);				
				positionStart = this.symbolSize.Height + positionStart;

				//create symbols sprite

				// let texture = this.spritesByName.forEach((value,key)=>{
				// 	console.log("keySymbol:",key);
					
				// });
				// console.log("textureSymbol",texture);


				//create symbols container
				let symbolContainerCenter = new PIXI.Container();	
				symbolContainerCenter.name = "symbolContainerCenter";			
				symbolContainerCenter.height = this.symbolSize.Height;
				symbolContainerCenter.width = this.symbolSize.Width;
				symbolContainerCenter.pivot.set(this.symbolSize.Height/2 , this.symbolSize.Width/2);
				symbolContainerCenter.position.set(this.symbolSize.Height/2 , this.symbolSize.Width/2);
				symbolContainerCenter.scale.set(1, AspectFixY);
				this.symbolContainerSprite[ri].push(symbolContainerCenter);
				symbolContainer.addChild(symbolContainerCenter)


				let symbol = new PIXI.AnimatedSprite([PIXI.Texture.EMPTY]);
				symbol.name = "symbolAnimatedSprite"
				//symbol.height = this.symbolSize.height;
				//symbol.width = this.symbolSize.width;
				//symbol.scale.set(1, 1);
				//symbol.anchor.set(0.5);
				//symbol.position.set(this.symbolSize.width/2 , this.symbolSize.height/2);
				symbol.zIndex = incZIndex;
				symbolContainerCenter.addChildAt(symbol, 0);

				// loop anim and add speed animation 
				symbol.loop = false;
				symbol.animationSpeed = 0.4;
				//symbol.accessibleChildren = true;
				symbol.accessible = true;
				symbol.name = 'symbol';
				//symbol.play();
				//reel.symbols.push(symbol);

				this.symbolPIXISprite[ri].push(symbol);
				symbol = null;
				
				incZIndex--;

				//create container for SRA value 				
				let shadowText = new PIXI.Text('');
				shadowText.x = Math.round((this.symbolSize.Width) / 2);
				shadowText.y = Math.round(this.symbolSize.Height / 2);
				shadowText.name = "SRAshadowText";
				symbolContainerCenter.addChildAt(shadowText, 1);

				//create container for SRA value 				
				let value = new PIXI.Text('');
				value.x = Math.round((this.symbolSize.Width) / 2);
				value.y = Math.round(this.symbolSize.Height / 2);
				value.name = "SRAvalue";
				symbolContainerCenter.addChildAt(value, 2);

				// create a new Sprfite from an image path.
				let jpImg = new PIXI.Sprite();
				jpImg.width = this.symbolSize.Width / 2;
				jpImg.height = this.symbolSize.Height / 5;
				jpImg.anchor.set(0.5,0.5);
				jpImg.x = Math.round((this.symbolSize.Width) / 2) ;
				jpImg.y = Math.round(this.symbolSize.Height / 2) ;
				jpImg.name = "SRAjackpot";
				symbolContainerCenter.addChildAt(jpImg, 3);
				shadowText = null;
				value = null;
				jpImg = null;
				symbolContainerCenter = null;

			}

			rc.zIndex = ZIndex.ReelContainer
			this.symbolPIXISprite[ri].reverse();
			this.symbolContainerSprite[ri].reverse();
			//this.reels.push(reel);

			//add reelbackground and reel symbols to container
			rc.mask = reelMask;
			reelContainer.addChild(reelMask);
			reelContainerBackground.addChild(reelBackground);
			reelContainer.addChild(rc);
			reelMask = null;
			reelBackground = null;
			rc = null;
			//reel = null;

		}
		
		if (this.containerSpinnableReelsSpine != undefined) {
			this.containerSpinnableReelsSpine.addChild(reelContainerBackground);
			this.containerSpinnableReelsSpine.addChild(reelContainer);
			//this.containerSpinnableReelsSpine.pivot.set(this.containerSpinnableReelsSpine.width/2,(this.containerSpinnableReelsSpine.height/2)*-1);
		} else {
			//create container for align the reels 
			let containerSpinnableReelsSpine = new PIXI.Container();
			containerSpinnableReelsSpine.name = "containerSpinableReelsBaseGame";			
			//containerSpinnableReelsSpine.scale.set(1, -1);
			containerSpinnableReelsSpine.position.y = Settings.ScreenHeight * (Settings.Screens - 1);
			containerSpinnableReelsSpine.addChild(reelContainerBackground);
			containerSpinnableReelsSpine.addChild(reelContainer);			
			this.containerSpinnableReelsSpine = containerSpinnableReelsSpine;
			this.app.stage.addChild(containerSpinnableReelsSpine);
		}
		//framesGame = null;
		REELWIDTH = null;
	}


	public GetView(): HTMLElement {
		return this.slotWindowElement;
	}

	public GetReelsContiner(): PIXI.Container {
		return this.reelContainer;
	}
		
	// window size in pixels
	public GetWindowSize(): Size {
		return this.windowRect.Size();
	}

	// window rect in pixels
	public GetWindowRect(): Rect {
		return this.windowRect;
	}

	// window size in number of symbols
	public GetWindowSymbolSize(): PlayWindow {
		return this.windowSymbolSize;
	}

	// extended window size in number of symbols - additional symbols are on top for the porpuse of spin animation
	public GetExtendendWindowSymbolSize() {
		return this.extendedWindowSymbolSize;
	}

	// returns size of one symbol in pixels
	public GetSymbolSize() {
		return this.symbolSize;
	}

	public GetCenterOfReel(): Point[] {

		this.reelWindowElemsList.forEach((reel: PIXI.Container) => {
			let width: number = reel.width;
			let height: number = reel.height;
			this.centerOfReel.push(new Point(width / 2 + reel.x, height / 2 + reel.height));
		});

		return this.centerOfReel;
	}

	public GetSymbolRect(column: number, row: number) {
		return new Rect(
			this.windowRect.x + this.params.leftBorderWidth + (column * this.symbolSize.Width),
			this.windowRect.y + this.params.topBorderWidth + this.params.bottomBorderWidth + (row * this.symbolSize.Height),
			this.symbolSize.Width,
			this.symbolSize.Height
		);
	}

	public GetAbsoluteSymbolRectReelRow(reel: number, rowOnReel: number) {
		return this.GetSymbolRect(reel, rowOnReel);
	}

	public CanvasesReelRow(): MyCanvas[][] {
		return null
	}

	//update canvas render 
	public Update() {		
		//this.app?.ticker?.update();
	}

    public Destroy(reason: string)
    {
		Log.Debug(this.logGroup, `Destroy(): ${reason}`);
        this.InternalDestroy();
        this.created = false;
		//this.restoreWebGlInterval.Stop();
    }

	protected InternalDestroy() {

		Log.Debug(this.logGroup, `InternalDestroy()`);
		if (!this.created)
		{
			Log.Error(this.logGroup, `InternalDestroy(): no app, not destroying anything`);
			return;
		}
		
		Safe(() =>this.reelWindowMaskList = []);;
		Safe(() =>this.reelElemsList = []);
		Safe(() =>this.symbolPIXISprite = []);
		Safe(() =>this.symbolContainerSprite = []);
		//this.reels = [];
		Safe(() =>this.reelWindowElemsList = []);
		Safe(() =>{
			this.containerSpinnableReelsSpine.removeChildren();
			this.containerSpinnableReelsSpine.removeFromParent();
		});
		this.reelBackgroundRect = []
	}

    protected created: boolean = false;
	protected containerSpinnableReelsSpine: PIXI.Container = null;
    public Create(containerSpinnableReelsSpine?: PIXI.Container , app? : PIXI.Application<HTMLCanvasElement>)
    {
		if(app !=  null) this.app = app;
        this.created = true;
		this.containerSpinnableReelsSpine = containerSpinnableReelsSpine;
		//try
		{
        	this.InternalCreate();
		}
    }

	public InternalCreate()
	{
		if (!this.created)
		{
			Log.Error(this.logGroup, `Create(): app not null, don't recreate`);
			return;
		}

		// if (!PIXI.utils.isWebGLSupported())
		// {
		// 	Log.Error(this.logGroup, `Webgl is not supported`);
		//     void service.api.frontendError(FrontendErrorCode.WebGLNotSupported, `${this.resid.ID()}`);this.resid.ID()
		// 	return;
		// }


		// Log.Debug(this.logGroup, `Create(): creating reels`);
	// 	if(this.containerSpinnableReelsSpine == undefined){
		
	// }
		
		
		//create Reels view 
		this.ConstructReels();

		//if(this.containerSpinnableReelsSpine == undefined){
		this.OnCreatedCallback?.();
		//}
	}

	//change resource for draw new symbol 
	public draw(reelIndex: number, rowIndex: number, symbolsToDraw: string) {
		//this.symbolPIXISprite[reelIndex][rowIndex].textures = this.spritesByName.get("Symbol_" + symbolsToDraw);
	}

	//play anim PIXI symbol
	protected running: boolean = false
	public PlaySymbolsAnim(symbolPositions: SymbolPositionToAnimate[], loopAnimation : boolean = true) {
		//get symbols for anim
		symbolPositions.forEach((s) => {
			this.symbolPIXISprite?.[s.reel]?.[s.row]?.play();
			this.symbolPIXISprite[s.reel][s.row].loop = loopAnimation;
			
		});
		this.running = true;
	}

	//stops anim PIXI symbol
	public StopSymbolsAnim() {
		if (this.running) {
			for (let reel = 0; reel < this.windowSymbolSize.Width; reel++) {
				for (let row = 0; row < this.extendedWindowSymbolSize.Height; row++) {
					this.symbolPIXISprite?.[reel]?.[row]?.gotoAndStop(0);
				}
			}
			this.running = false;
		}
	}

	public OnCreatedCallback: OnCreatedCallbackHandler = null;

	public GetReelBackgroundRect() : Rect[]{
		return this.reelBackgroundRect
	}

	public OnDestroyCallback: OnDestroyCallbackHandler = null;
}

export type OnCreatedCallbackHandler = () => void;


